import React, { useContext } from "react";
import { Box, Container, Grid, Link, Typography } from "@mui/material";
import ConfigContext from "../context/ConfigContext";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import { getStaticMapUrl } from "../util";
import StoreLocation from "./StoreLocation";
import moment from "moment";
import { STORAGE_BUCKET } from "../constants";
import { Link as RouterLink } from "react-router-dom";

export default function Footer(props) {
  const siteConfig = useContext(ConfigContext);

  const staticMapUrl = getStaticMapUrl(siteConfig.stores);

  return (
    <Box pt={10} sx={{ backgroundColor: "#303651", color: "#fff" }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item sm={2} xs={6}>
            <img
              alt={`${siteConfig.biz} Logo`}
              src={`${STORAGE_BUCKET}/img/b/${siteConfig.id}/logo400.webp`}
              style={{ width: "100%", filter: "grayscale(1)", borderRadius: "50%", backgroundColor: "#ECECEC" }}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Box mb={2} sx={{ color: "#000" }}>
              {siteConfig.stores.map((store, idx) => (
                <StoreLocation key={idx} store={store} index={idx} />
              ))}
            </Box>
          </Grid>
          <Grid item sm={6} xs={12}>
            <img style={{ width: "100%" }} src={staticMapUrl} alt="Store Location(s) Map" loading="lazy"/>
            <Box sx={{ textAlign: "right" }}>
              <Typography variant="caption" color="textSecondary">
                {process.env.REACT_APP_VERSION}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box textAlign={"center"}>
          <Box py={2}>
            {siteConfig.ig && (
              <Link color="inherit" style={{ padding: ".5rem" }} target="_blank" href={siteConfig.ig} underline="hover">
                <InstagramIcon />
              </Link>
            )}
            {siteConfig.fb && (
              <Link color="inherit" style={{ padding: ".5rem" }} target="_blank" href={siteConfig.fb} underline="hover">
                <FacebookIcon />
              </Link>
            )}
          </Box>
        </Box>
      </Container>
      <Box mt={6} px={4}>
        <Box
          py={4}
          sx={{ display: "flex", gap: "2rem", alignItems: "center", justifyContent: "space-between", borderTop: "1px solid #999", flexWrap: "wrap" }}
        >
          <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", flexWrap: "wrap" }}>
            <Link component={"a"} href="https://bakestreet.co" target="_blank" underline="none" sx={{ color: "inherit" }}>
              <img src={`https://res.cloudinary.com/draqf7k7f/image/upload/v1751065038/powered-outline_vnxicq.png`} alt="Powered by BakeStreet" loading="lazy" style={{ height: "25px" }} />
            </Link>
            <Typography variant="caption" display="block">
              &copy; {moment().format("YYYY")} BakeStreet Inc.
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: "2rem", alignItems: "center", flexWrap: "wrap" }}>
            <Link component={RouterLink} underline="none" to={"/store-policy"} style={{ color: "inherit", cursor: "pointer" }}>
              Store Policy
            </Link>
            <Link component={"a"} href="https://bakestreet.co/terms-of-service" target="_blank" underline="none" sx={{ color: "inherit" }}>
              Terms of Use
            </Link>
            <Link component={"a"} href="https://bakestreet.co/privacy-policy" target="_blank" underline="none" sx={{ color: "inherit" }}>
              Privacy Policy
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
